import React from 'react';

const BasicLayout = ({ children }) => {
	return (
		<>
			{children}
		</>
	);
};

export default BasicLayout;